const SVCFees = {
  OLPfee: 28.00, // Original license plate fee
  BTfee: 0, // BaseTax // 320.08
  RZfee: 0.50, // Reflectorization Fee  // 320.06(3)b eff9/1/2014
  FVfee: 0.50, // FRVIS Fee  // 320.03(5) eff 9/1/2014
  ACfee: 1.00, // Air Pollution Control Fee // 320.03(6)
  EMfee: 0.10, // Emergency Medical Services Fee // 320.0801(1)
  LEfee: 1.00, // Law Enforcement Radio Fee // 320.0802
  JJfee: 1.00, // Juvenile Justice GR Fee // 320.08046 eff9/1/2014
  STfee: 10.00, // State Transportation GVW Fee // 320.0801(2)
  ADfee: 2.50, // Accident Records - HSOT (Motorcycle Safety) // 320.08(1)c
  TDfee: 1.50, // Transportation Disadvantaged Fee // 320.03(9)
  SSfee: 1.20, // Surcharge State Transport // 320.0804 eff9/1/2014
  AVfee: 2.80, // Advanced Replacement Fee (ARF) // 320.0804 eff9/1/2014
  DDfee: 1.00, // Decal on Demand Fee (DOD) // 320.04(1)b  eff9/1/2014
  AFfee: 0, // Additional Fee based on Class Code
  AFfee38: 2.50, // 8,38,36 Fee of 2.50 semi-annual fee charged on 6-month semiannual registrations
  AFfee51: 1.00, // Additional Fee based on 'inside HS park fee'
  AFfee74: 27.00, // Additional Fee based on 'Dealer tag Use Tax'
  SPECfee: 5.00, // Additional Specialty Plate Processing Fee
  SPECfee65: 2.00, // Additional Specialty Plate Processing Fee for MC only
  PAfee: 0.25, // Property Appraiser fee for class 86
  MANUfee: 0.25, // Fee for _class code 86
  SVCfee: 2.50, // Registration Service Fee // 320.04(1)a eff 9/1/2014
  BFfee: 0.50, // County Branch Fee
};

export default SVCFees;



// WEBPACK FOOTER //
// ./src/modules/SVCFees.js